import type { IntentProps } from '../../../../core/slots/Intent/Intent.js';
import { useTooltipReducer } from '../../../core/components/overlay-tooltip/useTooltipReducer.js';
import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import type { CompactToolbarProps } from '../../../core/slots/toolbar/CompactToolbar.js';
import { getA11yToolbarConfig } from '../../../core/utils/zoom.js';
import { zIndexGaugeAreas } from '../../constants.js';

export type GaugeChartToolbarProps = {
  intents: IntentProps[];
  toolbar: Required<CompactToolbarProps>;
};

export const GaugeChartToolbar = (props: GaugeChartToolbarProps) => {
  const dispatch = useTooltipReducer();
  const { intents, toolbar } = props;

  if (toolbar.hidden) {
    return null;
  }

  return (
    <ChartToolbarRenderer
      visible={false}
      collapsed={false}
      draggable
      placement={toolbar.placement}
      initialA11yState={getA11yToolbarConfig({
        intent: !!intents,
      })}
      zIndex={zIndexGaugeAreas.toolbar}
      intents={intents}
      menuDisplayMode="never"
      toolbarDisplayMode="overlay"
      removeDragHandle
      visibleWhenMouseInBounds
      onToggleMenu={(isOpen) => {
        if (isOpen) {
          dispatch({ type: 'RESET_TOOLTIP' })();
        }
      }}
    />
  );
};
